export default __webpack_public_path__ + "static/media/shop11.b024b023.png";